import TileWrapper from '../TileWrapper'
import { useTile } from '../../context'
import RichTextContent from 'app/frontend/base/components/RichTextContent'

const CustomTextTile = () => {
  const { tile } = useTile()

  return (
    <TileWrapper>
      {tile.config?.text && <RichTextContent content={tile.config.text} />}
    </TileWrapper>
  )
}

export default CustomTextTile
